import { render, staticRenderFns } from "./PartnersWidget.vue?vue&type=template&id=20818eef&"
import script from "./PartnersWidget.vue?vue&type=script&lang=js&"
export * from "./PartnersWidget.vue?vue&type=script&lang=js&"
import style0 from "./PartnersWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports